"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitIntoMatchGroups = exports.getMatchRegex = exports.filtersResult = exports.sampleCreateDate = exports.filterRulesResults = exports.FAIL_STATUSES = exports.FILTER_ICONS = exports.RuleMatchChoices = void 0;
const lodash_1 = __importDefault(require("lodash"));
const getNewestCrumbForId_1 = __importDefault(require("./getNewestCrumbForId"));
const formatSampleValue_1 = __importDefault(require("./formatSampleValue"));
exports.RuleMatchChoices = {
    icontains: '(Text) Contains',
    'not-icontains': '(Text) Does not contain',
    iexact: '(Text) Exactly matches',
    'not-iexact': '(Text) Does not exactly match',
    ireversecontains: '(Text) Is in',
    'not-ireversecontains': '(Text) Is not in',
    istartswith: '(Text) Starts with',
    'not-istartswith': '(Text) Does not start with',
    iendswith: '(Text) Ends with',
    'not-iendswith': '(Text) Does not end with',
    igreater: '(Number) Greater than',
    iless: '(Number) Less than',
    idategreater: '(Date/time) After',
    idateless: '(Date/time) Before',
    idateequal: '(Date/time) Equals',
    boolean: '(Boolean) Is true',
    'not-boolean': '(Boolean) Is false',
    iexist: 'Exists',
    'not-iexist': 'Does not exist',
};
const TEXT_ENDS_WITH = '(Text) Ends with';
const TEXT_DOES_NOT_END_WITH = '(Text) Does not end with';
const TEXT_STARTS_WITH = '(Text) Starts with';
const TEXT_DOES_NOT_START_WITH = '(Text) Does not start with';
const TEXT_CONTAINS = '(Text) Contains';
const createId = () => {
    return Math.floor(Math.random() * (Math.pow(2, 53) - 1));
};
const escapeRegExp = function (str) {
    if (str == null) {
        return '';
    }
    return String(str).replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
};
exports.FILTER_ICONS = {
    true: 'check-alt',
    false: 'stopped',
};
exports.FAIL_STATUSES = ['fail', 'harmless-fail'];
const negator = 'not-';
const negatorRegex = /^not-/;
const ruleGroups = (rules) => lodash_1.default.groupBy(rules, rule => rule.group);
const hasNegationMatch = (rule) => Boolean(rule && negatorRegex.test(rule.match));
const hasNegationAction = (rule) => Boolean(rule && rule.action === 'stop');
const toUnnegatedMatch = (match) => (match || '').replace(negatorRegex, '');
const toNegatedMatch = (match) => `${negator}${toUnnegatedMatch(match)}`;
const toUiMatch = (rule) => hasNegationAction(rule)
    ? toNegatedMatch(rule.match)
    : toUnnegatedMatch(rule.match);
const toServerValue = (rule) => {
    const fieldsWithoutValues = [/exist/, /boolean/];
    const results = fieldsWithoutValues.map(type => type.test(toUnnegatedMatch(rule.match)));
    return lodash_1.default.isEmpty(lodash_1.default.compact(results)) ? rule.value : null;
};
const toServerRule = (rule) => {
    return Object.assign(Object.assign({}, rule), { match: toUnnegatedMatch(rule.match), action: hasNegationMatch(rule) ? 'stop' : 'continue', value: toServerValue(rule) });
};
const toUiRule = (rule) => (Object.assign(Object.assign({}, rule), { action: null, match: toUiMatch(rule) }));
const matchText = (rule) => {
    return exports.RuleMatchChoices[toUiMatch(rule)];
};
const findResult = (results, filterId) => lodash_1.default.find(results, result => result.id === filterId);
const filterSampleValue = (results, filterId) => formatSampleValue_1.default((findResult(results, filterId) || { sample: undefined }).sample);
const filterDidPass = (results, filterId) => !!(findResult(results, filterId) || {}).did_pass;
const resultsById = (filters) => lodash_1.default.reduce(filters, (result, filter) => (Object.assign(Object.assign({}, result), { [filter.id]: filter })), {});
exports.filterRulesResults = (rules, results, wouldWholeFilterRun) => rules.map(rule => (Object.assign(Object.assign({}, rule), { sample: filterSampleValue(results, rule.id) || '(missing value)', match: matchText(rule) || '(missing comparison)', status: filterDidPass(results, rule.id)
        ? 'success'
        : wouldWholeFilterRun
            ? 'harmless-fail'
            : 'fail' })));
const groupWouldRun = (group) => !lodash_1.default.some(group, groupItem => lodash_1.default.includes(exports.FAIL_STATUSES, groupItem.status));
exports.sampleCreateDate = (flow, nodeId) => {
    const crumb = getNewestCrumbForId_1.default(nodeId, flow.taskState);
    return crumb && crumb.start_time;
};
exports.filtersResult = (flow, filterNodeId) => {
    const node = flow.nodes[filterNodeId];
    const rules = node.params.filter_criteria || [];
    const crumb = getNewestCrumbForId_1.default(filterNodeId, flow.taskState);
    const wouldRun = Boolean(crumb && crumb.status === 'success');
    const results = lodash_1.default.get(flow, [
        'taskState',
        'output',
        filterNodeId,
        '_zap_data_filter_meta',
    ]) || [];
    return {
        wouldRun,
        rules,
        filters: exports.filterRulesResults(rules, results, wouldRun),
    };
};
const resultByGroup = (filters) => lodash_1.default.groupBy(filters, 'group');
const fixRuleIds = (rules = []) => {
    const reducer = (key, result, rule) => {
        if (!(rule[key] in result)) {
            const numValue = parseInt(lodash_1.default.toString(rule[key]), 10);
            result[rule[key]] = isNaN(numValue) ? createId() : numValue;
        }
        return result;
    };
    const newRuleIds = rules.reduce(lodash_1.default.partial(reducer, 'id'), {});
    const newGroupIds = rules.reduce(lodash_1.default.partial(reducer, 'group'), {});
    return rules.map((rule) => (Object.assign(Object.assign({}, rule), { id: newRuleIds[rule.id], group: newGroupIds[rule.group] })));
};
const MatchRegexKeys = {
    [TEXT_ENDS_WITH]: '',
    [TEXT_DOES_NOT_END_WITH]: '',
    [TEXT_STARTS_WITH]: '',
    [TEXT_DOES_NOT_START_WITH]: '',
    [TEXT_CONTAINS]: '',
};
exports.getMatchRegex = (method, value, sample) => {
    const escapedValue = escapeRegExp(value);
    return ({
        [TEXT_ENDS_WITH]: new RegExp(`${escapedValue}$`, 'gi'),
        [TEXT_DOES_NOT_END_WITH]: new RegExp(`.$`, 'gi'),
        [TEXT_STARTS_WITH]: new RegExp(`^${escapedValue}`, 'gi'),
        [TEXT_DOES_NOT_START_WITH]: new RegExp(`^.`, 'gi'),
        [TEXT_CONTAINS]: new RegExp(`${escapedValue}`, 'gi'),
    }[method] || escapeRegExp(sample));
};
exports.splitIntoMatchGroups = (string, re) => {
    if (!re.global) {
        throw new Error('splitIntoMatchGroups only works when the global regexp flag is set!');
    }
    let lastIndex = 0;
    const results = [];
    let m;
    while ((m = re.exec(string)) !== null) {
        results.push({
            isMatch: false,
            value: string.substring(lastIndex, m.index),
        });
        results.push({ isMatch: true, value: m[0] });
        lastIndex = re.lastIndex;
        if (re.lastIndex === m.index) {
            return results.filter(r => r.value);
        }
    }
    results.push({ isMatch: false, value: string.substring(lastIndex) });
    return results.filter(r => r.value);
};
exports.default = {
    ruleGroups,
    filterRulesResults: exports.filterRulesResults,
    filtersResult: exports.filtersResult,
    toServerRule,
    toUiRule,
    toUiMatch,
    createId,
    fixRuleIds,
    FILTER_ICONS: exports.FILTER_ICONS,
    resultsById,
    groupWouldRun,
    resultByGroup,
    sampleCreateDate: exports.sampleCreateDate,
    FAIL_STATUSES: exports.FAIL_STATUSES,
    getMatchRegex: exports.getMatchRegex,
    splitIntoMatchGroups: exports.splitIntoMatchGroups,
};
